import { render, staticRenderFns } from "./column-table.vue?vue&type=template&id=d535fbf0&scoped=true&"
import script from "./column-table.vue?vue&type=script&lang=js&"
export * from "./column-table.vue?vue&type=script&lang=js&"
import style0 from "./column-table.vue?vue&type=style&index=0&id=d535fbf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d535fbf0",
  null
  
)

export default component.exports